import { BLENDED_BY_OPTIONS } from '#models/business/NewProduct/blendedBy';
import { BOTTLED_BY_OPTIONS } from '#models/business/NewProduct/bottledBy';
import { DISTILLED_BY_OPTIONS } from '#models/business/NewProduct/distillation';
import { FERMENTED_BY_OPTIONS } from '#models/business/NewProduct/fermentation';
import { MASHED_BY_OPTIONS } from '#models/business/NewProduct/mashing';

const mapActionBy = options => params =>
  Object.values(options).reduce(
    (prevValues, actValue) => ({
      ...prevValues,
      ...(params[actValue] ? { [actValue]: parseInt(params[`${actValue}Manual`]) } : {})
    }),
    {}
  );

const mapCheckActionBy = options => params =>
  Object.values(options).reduce(
    (prevValues, actValue) => ({
      ...prevValues,
      ...(params[actValue] ? { [actValue]: true } : {})
    }),
    {}
  );

const mapBottledBy = mapActionBy(BOTTLED_BY_OPTIONS);
const mapMashedBy = mapActionBy(MASHED_BY_OPTIONS);
const mapFermentedBy = mapActionBy(FERMENTED_BY_OPTIONS);
const mapDistilledBy = mapActionBy(DISTILLED_BY_OPTIONS);
const mapBlendedBy = mapCheckActionBy(BLENDED_BY_OPTIONS);

export const mapCreateProductData = ({
  productName,
  productDate,
  templateType,
  totalCirculatingBottles,
  unitsToBeCreated,
  productPictureURL,
  tastingNotes,
  barleyVariety,
  farmName,
  fieldName,
  maltedBy,
  firstTemperature,
  secondTemperature,
  thirdTemperature,
  gravity,
  averageHours,
  typeOfYeast,
  minHydrometer,
  maxHydrometer,
  importersName,
  website,
  emailAddress,
  maturationNotes,
  hideBottleNumber,
  showCustomSection,
  customSections,
  ...props
}) => ({
  productName,
  productDate,
  templateType,
  totalCirculatingBottles,
  unitsToBeCreated,
  productPictureURL,
  bottledBy: mapBottledBy(props),
  tastingNotes,
  barleyVariety,
  farmName,
  fieldName,
  maltedBy,
  mashedBy: mapMashedBy(props),
  blendedBy: mapBlendedBy(props),
  firstTemperature,
  secondTemperature,
  thirdTemperature,
  gravity,
  fermentedBy: mapFermentedBy(props),
  averageHours,
  typeOfYeast,
  distilledBy: mapDistilledBy(props),
  minHydrometer,
  maxHydrometer,
  importersName,
  website,
  emailAddress,
  maturationNotes,
  hideBottleNumber: !!hideBottleNumber,
  showCustomSection,
  customSections
});

export const mapEditProductData = ({
  id,
  productName,
  productDate,
  templateType,
  totalCirculatingBottles,
  unitsToBeCreated,
  productPictureURL,
  nose,
  palate,
  tastingNotes,
  barleyVariety,
  farmName,
  fieldName,
  maltedBy,
  firstTemperature,
  secondTemperature,
  thirdTemperature,
  gravity,
  averageHours,
  typeOfYeast,
  minHydrometer,
  maxHydrometer,
  importersName,
  website,
  emailAddress,
  maturationNotes,
  hideBottleNumber,
  showCustomSection,
  customSections,
  ...props
}) => ({
  id,
  productName,
  productDate,
  templateType,
  totalCirculatingBottles,
  unitsToBeCreated,
  productPictureURL,
  bottledBy: mapBottledBy(props),
  nose,
  palate,
  tastingNotes,
  barleyVariety,
  farmName,
  fieldName,
  maltedBy,
  mashedBy: mapMashedBy(props),
  blendedBy: mapBlendedBy(props),
  firstTemperature,
  secondTemperature,
  thirdTemperature,
  gravity,
  fermentedBy: mapFermentedBy(props),
  averageHours,
  typeOfYeast,
  distilledBy: mapDistilledBy(props),
  minHydrometer,
  maxHydrometer,
  importersName,
  website,
  emailAddress,
  maturationNotes,
  hideBottleNumber: !!hideBottleNumber,
  showCustomSection,
  customSections
});
